module.exports = __webpack_public_path__ + "img/news1.03be4c54.png";